export enum InvoicesParserTab {
  Documents = 'documents',
  Invoices = 'invoices',
  Jobs = 'jobs',
  Upload = 'upload',
  Integrity = 'integrity',
}
